<template>
    <div class="components-page-manage scrollbar-wrapper">
        <!-- <p class="page-title text-center">页面管理</p> -->
        <el-scrollbar style="height: 50%;padding-top: 40px;" class="components-main-conten">
            <div class="bottom-btn-wrapper">
                <el-button type="primary" size="small" @click="addPage()">新增场景</el-button>
            </div>

            <!--加载页面设置-->
            <!--<div class="page-item clearfix">-->
            <!--<div class="inline-block">-->
            <!--<span class="page-item-index"><i class="iconfont iconloading"></i></span>-->
            <!--加载页-->
            <!--</div>-->
            <!--<div class="pull-right custom-loading-btn">-->
            <!--<el-button size="mini">自定义设置</el-button>-->
            <!--</div>-->
            <!--</div>-->
            <draggable v-model="projectData.pages" group="uuid">

                <div class="page-item clearfix" v-for="(page, index) in projectData.pages" :key="page.uuid"
                    :class="{ active: activePageUUID === page.uuid }" @click.stop="changeActivePage(page)">

                    <span class="page-item-index" style="width:20px;">{{ index + 1 }}</span>
                    <div style="position: relative;overflow: hidden;pointer-events: none;" class="sceenshot"
                        :style="{ ...getCommonStyle({ ...page.commonStyle }), 'width': projectData.width + 'px', 'height': projectData.height + 'px', 'zoom': 144 / projectData.width }">
                        <!--页面组件列表展示-->
                        <div v-for="item in page.elements" :key="item.uuid" :uuid="item.uuid"
                            :defaultStyle="item.commonStyle"
                            :style="{ ...getCommonStyle({ width: item.commonStyle.width, height: item.commonStyle.height, left: item.commonStyle.left, top: item.commonStyle.top, position: item.commonStyle.position }), overflow: 'hidden' }">
                            <component :style="getCommonStyle({ ...item.commonStyle, top: 0, left: 0 })" :is="item.elName"
                                class="element-on-edit-pane" v-bind="{...item.propsValue, commonStyle: item.commonStyle}" :item="item" />
                        </div>
                    </div>

                    <span class="page-item-btn-wrapper">
                        <el-link icon="el-icon-document-copy" @click="copyPage(page)"></el-link>
                        <el-link icon="el-icon-setting" @click="settingPage(page)"></el-link>
                        <el-link icon="el-icon-delete" @click="deletePage(page)" style="margin-left: 0px;"></el-link>
                    </span>



                    <!-- <div class="page-item-btn-wrapper pull-right width20">
          <el-dropdown>
            <span class="el-dropdown-link">
              <i class="el-icon-more-outline"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="btn-item" @click="copyPage(page)"><i class="el-icon-document-copy"></i> 复制页面</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="btn-item" @click="addPage(page)"><i class="el-icon-document-add"></i> 新增页面</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="btn-item" @click="deletePage(page)"><i class="el-icon-delete"></i> 删除页面</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
                </div>

            </draggable>


        </el-scrollbar>


        <div v-if="activePage" style="overflow: hidden;height:50%">
            <el-divider style="margin: 5px;">场景元素</el-divider>
            <ul style="overflow: auto;height:calc(100% - 10px);padding-left:10px;padding-right:10px;">
                <li style="padding-bottom: 5px;" v-for="element in activePage.elements" :key="element.uuid"
                    @click="handleElementClick(element.uuid)" @dblclick="handleElementEdit(element)"
                    :style="{ 'background-color': element.uuid === activeElementUUID ? '#eee' : 'white' }">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <template v-if="element.elName === 'qk-image'">
                                <el-image style="width: 30px; height: 30px" fit="cover"
                                    :src="element.propsValue.imageSrc" />
                            </template>
                            <template v-else-if="element.elName === 'qk-video'">
                                <video style="width: 30px; height: 30px" :src="typeof(element.propsValue.videoSrcList) === 'string' ? element.propsValue.videoSrcList : element.propsValue.videoSrcList[0]" />
                            </template>
                            <template v-else-if="element.elName === 'qk-bg-music'">
                                <span
                                    style="display: block;width: 30px; height: 30px;border:1px solid;text-align: center;line-height: 30px;">音</span>
                            </template>
                            <template v-else-if="element.elName === 'qk-iframe'">
                                <span
                                    style="display: block;width: 30px; height: 30px;border:1px solid;text-align: center;line-height: 30px;">网</span>
                            </template>
                            <template v-else-if="element.elName === 'qk-text'">
                                <span
                                    style="display: block;width: 30px; height: 30px;border:1px solid;text-align: center;line-height: 30px;">文</span>
                            </template>
                            <template v-else-if="element.elName === 'qk-image-carousel'">
                                <el-image style="width: 30px; height: 30px" fit="cover"
                                    :src="element.propsValue.imageSrcList[0]" />
                            </template>
                            <template v-else-if="element.elName === 'qk-marquee'">
                                <span
                                    style="display: block;width: 30px; height: 30px;border:1px solid;text-align: center;line-height: 30px;">告</span>
                            </template>
                            <template v-else>
                                <span
                                    style="display: block;width: 30px; height: 30px;border:1px solid;text-align: center;line-height: 30px;">他</span>
                            </template>
                        </el-col>

                        <el-col :span="8" style="font-size: 12px;line-height: 30px">
                            <template v-if="element.elName === 'qk-image'">
                                图片
                            </template>
                            <template v-else-if="element.elName === 'qk-video'">
                                视频
                            </template>
                            <template v-else-if="element.elName === 'qk-bg-music'">
                                音乐
                            </template>
                            <template v-else-if="element.elName === 'qk-iframe'">
                                网页
                            </template>
                            <template v-else-if="element.elName === 'qk-text'">
                                文本
                            </template>
                            <template v-else-if="element.elName === 'qk-marquee'">
                                公告
                            </template>
                            <template v-else-if="element.elName === 'qk-image-carousel'">
                                轮播
                            </template>
                            <template v-else>
                                其他
                            </template>
                        </el-col>


                        <el-col :span="8">
                            <div style="display:flex;    display: flex;
    justify-content: space-around;
    height: 30px;
    align-items: center;
    font-size: 15px;">
                                <i class="el-icon-edit" style="cursor: pointer;" @click.stop="handleElementEdit(element)"></i>
                                <i class="el-icon-delete" style="cursor: pointer;"  @click.stop="handleElementDelete(element.uuid)"></i>
                            </div>
                        </el-col>

                    </el-row>


                </li>
            </ul>



        </div>
        <el-dialog title="场景轮播配置" :visible.sync="pageSettingDialog.show" width="60%">
            <div>
                <el-form ref="form" label-width="150px">
                    <el-form-item label="场景展示时长">
                        <el-input v-model="pageSettingDialog.pageConfig.duration" style="width:150px">
                            <template #append>秒</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="每天展示时段">
                       <div>
                            <el-radio v-model="pageSettingDialog.pageConfig.enablePlayRange" :label="false">全天播放</el-radio>
                            <el-radio v-model="pageSettingDialog.pageConfig.enablePlayRange" :label="true">指定时间段</el-radio>
                       </div>

                        <el-time-picker v-if="pageSettingDialog.pageConfig.enablePlayRange" value-format='HH:mm:ss' 
                            is-range v-model="pageSettingDialog.pageConfig.playTimeRange"
                            range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="每周展示周期">
                        <div>
                            <el-radio v-model="pageSettingDialog.pageConfig.enableWeeklyDays" :label="false">周一至周日整周播放</el-radio>
                            <el-radio v-model="pageSettingDialog.pageConfig.enableWeeklyDays" :label="true">指定周几播放</el-radio>
                        </div>
                        <el-checkbox-group v-model="pageSettingDialog.pageConfig.playWeeklyDays" v-if="pageSettingDialog.pageConfig.enableWeeklyDays" >
                            <el-checkbox v-for="one in weekOptions" :label="one.value" :key="one.value">{{ one.label }}</el-checkbox>
                        </el-checkbox-group>

                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pageSettingDialog.show = false">取 消</el-button>
                <el-button type="primary" @click="finishSettingPage()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import editorProjectConfig from '@client/pages/editor/DataModel'
import { _qk_register_components_object } from '@client/plugins/index'
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
        // 批量注册qk组件
        ..._qk_register_components_object,
    },
    computed: {
        ...mapState({
            projectData: state => state.editor.projectData,
            activePageUUID: state => state.editor.activePageUUID,
            activeElementUUID: state => state.editor.activeElementUUID
        }),
        activePage() {
            return this.projectData.pages.find(page => page.uuid === this.activePageUUID)
        },

        weekOptions() {
            const arr1 = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
            const arr2 = [1, 2, 3, 4, 5, 6, 0];

            let rets = []
            for(let i = 0; i < 7; i++) {
                rets.push({
                    label: arr1[i],
                    value: arr2[i]
                })
            }

            return rets;
        }
    },
    data() {
        return {
            pageSettingDialog: {
                show: false,
                pageConfig: {
                    duration: 600,
                    playTimeRange: ['00:00:00', '23:59:59'],
                    playWeeklyDays: [],
                    enablePlayRange: false,
                    enableWeeklyDays: false
                }
            },
            
            getCommonStyle: editorProjectConfig.getCommonStyle,
        }
    },
    methods: {
        handleElementClick(uuid) {
            this.$store.dispatch('setActiveElementUUID', uuid);
        },
        handleElementEdit(element) {
            this.$store.dispatch('setActiveElementUUID', element.uuid);
            this.$store.dispatch('editActiveElement', element);
        },
        handleElementDelete(uuid) {
            this.$store.dispatch('deleteElement', uuid);
        },
        /**
         * 切换选中页面
         * @param item
         */
        changeActivePage(item) {
            this.$store.dispatch('setActivePageUUID', item.uuid)
        },
        copyPage(item) {
            this.$store.dispatch('copyPage', item.uuid)
        },
        addPage(item) {
            this.$store.dispatch('addPage', item ? item.uuid : '')
        },
        deletePage(item) {
            this.$store.dispatch('deletePage', item.uuid)
        },
        settingPage(item, idx) {
            this.pageSettingDialog.pageConfig.duration = item.config.duration || 60 * 10;
            this.pageSettingDialog.pageConfig.playTimeRange = item.config.playTimeRange || ['00:00:00', '23:59:59'];
            this.pageSettingDialog.pageConfig.playWeeklyDays = item.config.playWeeklyDays || [];
            this.pageSettingDialog.pageConfig.enablePlayRange = item.config.enablePlayRange || false;
            this.pageSettingDialog.pageConfig.enableWeeklyDays = item.config.enableWeeklyDays || false;
            
            this.pageSettingDialog.show = true
        },
        finishSettingPage() {
            this.activePage.config.duration = this.pageSettingDialog.pageConfig.duration;
            this.activePage.config.playTimeRange = this.pageSettingDialog.pageConfig.playTimeRange;
            this.activePage.config.playWeeklyDays = this.pageSettingDialog.pageConfig.playWeeklyDays;
            this.activePage.config.enablePlayRange = this.pageSettingDialog.pageConfig.enablePlayRange;
            this.activePage.config.enableWeeklyDays = this.pageSettingDialog.pageConfig.enableWeeklyDays;

            this.$store.dispatch('addHistoryCache')

            this.pageSettingDialog.show = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.components-page-manage {
    height: 100%;
    padding-top: 10px;
    padding-bottom: 0px;
    position: relative;
}

.page-title {
    position: absolute;
    top: 16px;
    left: 0;
    width: 100%;
}

.page-item {
    width: 100%;
    //cursor: pointer;
    //transition: all 0.28s;
    border-bottom: 1px solid #e6ebed;
    background: white;
    color: #666666;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    &>.pull-right {
        width: 20px;

        &.custom-loading-btn {
            width: 84px;
        }
    }

    &>.inline-block {
        flex: 1;
    }

    &:hover {
        background-color: #eee;
        //   .page-item-btn-wrapper {
        //     display: block;
        //     opacity: 1;
        //   }
    }

    &.active {

        //background-color: #eee;
        //border: 3px solid blue;
        .page-item-btn-wrapper {
            display: flex;
        }

        color: #111;

        .page-item-index {
            background: $primary;
            color: white;
        }

        .sceenshot {
            border: 3px solid $primary;
        }
    }

    .sceenshot {
        border: 3px solid #B3B3B3;
    }

    .page-item-index {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 20px;
        text-align: center;
        background-color: #ccc;
        color: #fff;
        margin-top: 35px;
        margin-right: 5px;
    }

    .page-item-btn-wrapper {
        display: none;
        width: 30px;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }
}

.bottom-btn-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    text-align: center;
    width: 100%;
    padding-top: 0px;
}
</style>
